<template>
  <base-dialog @cancel="cancelDialog">
    <div slot="header">渠道项目报备</div>
    <div slot="body">
      <a-alert class="mb-4" :show-icon="false" message="填写详细的项目信息，我们会尽快与您取得联系，项目报备有效期3个月" banner />
      <a-form
        :form="form.fc">
        <a-form-item label="客户企业名称" v-bind="formItemLayout">
          <a-input v-decorator="decorators.enterprise_name" placeholder="请填写企业全称" />
        </a-form-item>
        <a-form-item label="项目名称" v-bind="formItemLayout">
          <a-input v-decorator="decorators.name" placeholder="项目的准确名称" />
        </a-form-item>
        <a-form-item label="项目规模" v-bind="formItemLayout">
          <a-input type="number" v-decorator="decorators.amount" placeholder="请填写项目预算金额" addon-after="万元" />
        </a-form-item>
        <a-form-item label="项目所在地" v-bind="formItemLayout">
          <a-cascader v-decorator="decorators.address" :options="cities" placeholder="项目执行城市" />
          <!-- <a-input v-decorator="decorators.address" placeholder="项目执行城市" /> -->
        </a-form-item>
        <a-form-item label="客户联系人" v-bind="formItemLayout">
          <a-input v-decorator="decorators.contact" placeholder="请填写客户联系人" />
        </a-form-item>
        <a-form-item label="客户联系人所属部门" v-bind="formItemLayout">
          <a-input v-decorator="decorators.department" placeholder="请填写客户联系人所属部门" />
        </a-form-item>
        <a-form-item label="客户联系人职位" v-bind="formItemLayout">
          <a-input v-decorator="decorators.position" placeholder="请填写客户联系人职位" />
        </a-form-item>
        <a-form-item label="备注" v-bind="formItemLayout">
          <a-textarea v-decorator="decorators.description" placeholder="其他重要信息" />
        </a-form-item>
      </a-form>
    </div>
    <div slot="footer">
      <a-button type="primary" @click="handleConfirm" :loading="loading">{{ $t('dialog.ok') }}</a-button>
      <a-button @click="cancelDialog">{{ $t('dialog.cancel') }}</a-button>
    </div>
  </base-dialog>
</template>

<script>
import DialogMixin from '@/mixins/dialog'
import WindowsMixin from '@/mixins/windows'

export default {
  name: 'createReportProjectDialog',
  mixins: [DialogMixin, WindowsMixin],
  data () {
    return {
      loading: false,
      form: {
        fc: this.$form.createForm(this),
      },
      decorators: {
        name: [
          'name',
          {
            rules: [
              { required: true, message: '请填写项目的准确名称' },
            ],
          },
        ],
        enterprise_name: [
          'enterprise_name',
          {
            rules: [
              { required: true, message: '请填写企业全称' },
            ],
          },
        ],
        amount: [
          'amount',
        ],
        address: [
          'address',
        ],
        contact: [
          'contact',
        ],
        department: [
          'department',
        ],
        position: [
          'position',
        ],
        description: [
          'description',
        ],
      },
      formItemLayout: {
        wrapperCol: {
          span: 19,
        },
        labelCol: {
          span: 5,
        },
      },
      cities: [],
    }
  },
  async created () {
    const { data: { data = [] } } = await this.fetchCities()
    this.cities = data
  },
  methods: {
    fetchCities () {
      return this.$http.get('/v2/cities?nation_code=CN')
    },
    doAssociate (data) {
      return new this.$Manager('projectrecords').create({
        data: data,
      })
    },
    async handleConfirm () {
      this.loading = true
      try {
        let values = await this.form.fc.validateFields()
        if (values.address) {
          values = {
            ...values,
            address: values.address[1],
          }
        }
        await this.doAssociate(values)
        this.$message.success('新建成功')
        this.loading = false
        this.cancelDialog()
        this.params.refresh()
      } catch (error) {
        this.loading = false
        throw error
      }
    },
  },
}
</script>
